/**
 * アプリケーションの設定値定義
 * @type     {object} APP設定値定義
 */
const config = {
  // フロントエンドAPI接続情報
  API_PROTOCOL: 'https',
  API_HOST: 'tsreejoins-trial.tsr-net.co.jp',
  API_PORT: '443',
  API_NAME: 'tjs-ex/bff',
  // 会社コード(CMJ)
  COMPANY_CODE_CMJ: '001',

  // ダウンロードステータスポーリング間隔
  DOWNLOAD_POLLING: {
    // 企業検索:5秒
    COMPANY_DOWNLOAD: 5000,
    // ターゲット検索:5秒
    TARGET_DOWNLOAD: 5000,
  },
  // 名刺情報取込ステータスポーリング間隔
  IMPORT_POLLING: {
    // 名刺情報取込:5秒
    BUSINESSCARD: 5000,
  },
  // ファイルサイズ上限(1ファイル当たり)
  FILE_SIZE_LIMIT: {
    // 企業更新:500MB
    UPLOAD_COMPANY: 524288000,
    // 企業情報マッチング:50MB
    MATCHING_COMPANY: 52428800,
  },
  // ファイル名上限(拡張子含まない)
  FILE_NAME_LIMIT: {
    // 企業更新
    UPLOAD_COMPANY: 50,
    // 企業情報マッチング
    MATCHING_COMPANY: 50,
  },
  // 最大追加件数
  MAX_ADD_COUNT: {
    UPLOAD_COMPANY: 10,
  },
  // アップロードファイル数上限
  FILE_UPLOAD_LIMIT: {
    UPLOAD_COMPANY: 10,
  },
  // 検索最大取得件数
  SEARCH_LIMIT_COUNT: {
    COMPANY: 100,
    TARGET: 100,
    ADDITIONAL_ITEM: 20,
  },
  // 取引情報検索フラグ
  TRADE_SEARCH_FLG: {
    FLG1: {
      NAME: '●●●●有無',
      TRUE: '有り',
      FALSE: '無し',
      NONE: '指定せず検索',
      DISP: '0',
    },
    FLG2: {
      NAME: '〇〇〇〇有無',
      TRUE: '有り',
      FALSE: '無し',
      NONE: '指定せず検索',
      DISP: '0',
    },
  },
  // ダウンロードパス
  DOWNLOAD_PATH: 'trush',
};

export default config;
